<div class="team-card">
    <img [src]="teamImage"/>
    <div class="copy-container">
        <h5>Tamlyn Stevens</h5>
        <p>Company Secretary</p>
    </div>
</div> 